import { CompanyUserAttributes, CompanyUserRole } from '@/types'
import { CreateCompanyUserMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { Text } from '@/components/base/text'
import { ErrorMessage, Field, Label } from '../base/fieldset'
import { Selector as RoleSelector } from './role/selector'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    fieldErrors,
    attributes,
    setAttributes
  } = useForm<CreateCompanyUserMutation, CompanyUserAttributes, never, never>({
    defaultValues: {
      role: CompanyUserRole.Crew,
      email: '',
    },
    mutation: CreateMutation,
    resultKey: 'createCompanyUser',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Email', field: 'email', type: 'email' }) }
      <Field>
        <Label>Role</Label>
        <RoleSelector
          invalid={!!fieldErrors?.role}
          value={attributes.role}
          onChange={value => setAttributes({ ...attributes, role: value?.id as CompanyUserRole || CompanyUserRole.Crew }) }
        />
        { fieldErrors?.role && <ErrorMessage>{ fieldErrors?.role }</ErrorMessage> }
      </Field>
      <div>
        <Text>
          <strong>In case you need it</strong><br />
          If Ripple doesn't recognise their email, we'll invite them to join
          Ripple first. They'll then need to accept your invitation before you
          can add them to places around Ripple
        </Text>
      </div>
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
